import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import CommentsSection from './components/CommentsSection';
import RankingSection from './components/RankingSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <AppSection />
        <FeaturesSection />
        <CommentsSection />
        <RankingSection />
        <CardsSection />
        <TopicsSection />
        <MediaSection />
        <FaqSection />
        <CarouselSection />
        <UpdatesSection />
        <IndexSection />
        <ContactSection />
        <AboutSection />
      </main>
      <Footer />
    </>
  );
}